import View from './View';

export { default as View, getRecordingModalStyles } from './View';

export default View;
